import { useEffect, useState } from 'react'
import { getJson, getUrl } from '../providers/data'

export interface ConfigurationOut {
  id: string;
  welcomeMessage?: string | null;
  sync_to_zaaksysteem?: boolean | null;
  casetype_uuid?: string | null;
  trigger_subject?: string | null;
  field_mapping?: Record<string, any> | null;
  name?: string | null;
  organization_type?: string | null;
}

export type OrganizationSettings = ConfigurationOut

let cachedSettings: OrganizationSettings | null = null
let fetchPromise: Promise<OrganizationSettings | null> | null = null

const fetchSettings = async (): Promise<OrganizationSettings | null> => {
  try {
    const data = await getJson<OrganizationSettings[]>(`${getUrl()}/configuration`)
    return Array.isArray(data) ? data[0] : data
  } catch {
    return null
  }
}

export const useOrganizationSettings = () => {
  const [settings, setSettings] = useState<OrganizationSettings | null>(cachedSettings)

  useEffect(() => {
    let isMounted = true

    if (cachedSettings) {
      setSettings(cachedSettings)
      return
    }

    if (!fetchPromise) {
      fetchPromise = fetchSettings()
    }

    void fetchPromise.then((result) => {
      if (isMounted) {
        cachedSettings = result
        setSettings(result)
        fetchPromise = null
      }
    })

    return () => {
      isMounted = false
    }
  }, [])

  return settings
}

export const clearSettingsCache = (): void => {
  cachedSettings = null
  fetchPromise = null
}